const environmentLocal = {
  environment: process.env.REACT_APP_ENVIRONMENT,
  isAmbienteManutencao: process.env.REACT_APP_IS_AMBIENTE_MANUTENCAO,
  periodoEstimado: process.env.REACT_APP_PERIODO_ESTIMADO_MANUTENCAO,
  isArrecadacaoManutencao:
    process.env.REACT_APP_IS_ARRECADACAO_AMBIENTE_MANUTENCAO,
  isDiefManutencao: process.env.REACT_APP_IS_DIEF_AMBIENTE_MANUTENCAO,
  urlLocal: process.env.REACT_APP_URL_LOCAL,
  isLojaSerproHabilitada: process.env.REACT_APP_IS_LOJA_SERPRO_HABILITADA,
  urlLojaSerpro: process.env.REACT_APP_URL_LOJA_SERPRO,
};

export const environment = {
  environment: environmentLocal.environment ?? 'hom',
};

export const manutencao = {
  isAmbienteManutencao:
    environmentLocal.isAmbienteManutencao ??
    '',
  periodoEstimado:
    environmentLocal.periodoEstimado ??
    '',
};

export const urlLocal = environmentLocal.urlLocal ?? 'https://localhost:3000/';
export const urlDes = 'https://des-pgrm.np.estaleiro.serpro.gov.br';

export const lojaSerpro = {
  habilitada:
    environmentLocal.isLojaSerproHabilitada ??
    'false',
  url: environmentLocal.urlLojaSerpro ?? '/',
};

export const sistemasManutencao = {
  isArrecadacaoManutencao:
    environmentLocal.isArrecadacaoManutencao ??
    '',
  isDiefManutencao:
    environmentLocal.isDiefManutencao ??
    '',
};
